import { METRIC_NAMES, METRIC_TYPE, WIDGET_LOGICAL_NAMES } from '@config/Consts';

const metricsConfig = {
  [WIDGET_LOGICAL_NAMES.IN_QUEUE]: {
    total_unassigned: {
      metricLabelI18nKey: 'metric_total_unassigned_conversations',
      metricTooltipI18nKey: 'queue_health_total_in_queue_tooltip',
      metricName: METRIC_NAMES.SKILL_UNASSIGNED_CONVERSATIONS,
      metricUnitType: METRIC_TYPE.NONE,
      extensionMetrics: [METRIC_NAMES.OVERDUE_IN_QUEUE],
    },
    overdue: {
      metricLabelI18nKey: 'metric_overdue_in_queue',
      metricTooltipI18nKey: 'metric_overdue_in_queue_tooltip',
      metricName: METRIC_NAMES.OVERDUE_IN_QUEUE,
      metricUnitType: METRIC_TYPE.NONE,
    },
    skill_name: {
      metricLabelI18nKey: 'metric_skill_name',
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '45%',
        minWidth: '90px',
      },
      metricColumnHeaderI18nKey: 'queue_health_column_skill',
      metricName: METRIC_NAMES.IN_QUEUE_SKILL_NAME,
      metricUnitType: METRIC_TYPE.NONE,
    },
    unassigned_conversations: {
      metricLabelI18nKey: 'metric_unassigned_conversations',
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '20%',
        minWidth: '70px',
      },
      metricColumnHeaderI18nKey: 'queue_health_column_in_queue',
      metricTooltipI18nKey: 'queue_health_column_in_queue_tooltip',
      metricName: METRIC_NAMES.SKILL_UNASSIGNED_CONVERSATIONS,
      metricUnitType: METRIC_TYPE.NONE,
    },
    skill_wait_time: {
      metricLabelI18nKey: 'metric_wait_time_agent_assignment_90_percentile',
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '35%',
        minWidth: '70px',
      },
      metricColumnHeaderI18nKey: 'queue_health_column_wait_time',
      metricTooltipI18nKey: 'queue_health_column_wait_time_tooltip',
      metricName: METRIC_NAMES.IN_QUEUE_SKILL_WAIT_TIME,
      metricUnitType: METRIC_TYPE.DURATION,
    },
  },
  [WIDGET_LOGICAL_NAMES.SHIFT_STATUS]: {
    assigned: {
      metricLabelI18nKey: 'metric_assigned_conversation',
      metricTooltipI18nKey: 'metric_assigned_conversation_tooltip',
      metricName: METRIC_NAMES.ASSIGNED_CONVERSATIONS,
      metricUnitType: METRIC_TYPE.NONE,
      extensionMetrics: [METRIC_NAMES.OVERDUE_ASSIGNED],
    },
    overdue: {
      metricLabelI18nKey: 'metric_overdue_assigned',
      metricTooltipI18nKey: 'metric_overdue_assigned_tooltip',
      metricName: METRIC_NAMES.OVERDUE_ASSIGNED,
      metricUnitType: METRIC_TYPE.NONE,
    },
    unassigned: {
      metricLabelI18nKey: 'metric_unassigned_conversations',
      metricTooltipI18nKey: 'queue_health_total_in_queue_tooltip',
      metricName: METRIC_NAMES.SKILL_UNASSIGNED_CONVERSATIONS,
      metricUnitType: METRIC_TYPE.NONE,
      extensionMetrics: [METRIC_NAMES.OVERDUE_IN_QUEUE],
    },
    overdue_unassigned: {
      metricLabelI18nKey: 'metric_overdue_in_queue',
      metricTooltipI18nKey: 'metric_overdue_in_queue_tooltip',
      metricName: METRIC_NAMES.OVERDUE_IN_QUEUE,
      metricUnitType: METRIC_TYPE.NONE,
    },
    load: {
      metricLabelI18nKey: 'metric_load',
      metricTooltipI18nKey: 'metric_load_tooltip',
      metricName: METRIC_NAMES.LOAD_CONVERSATIONS,
      metricUnitType: METRIC_TYPE.PERCENTAGE,
      extensionMetrics: [METRIC_NAMES.HUMAN_ONLINE_LOAD, METRIC_NAMES.HUMAN_AWAY_LOAD],
      hideExtensionMetricByUseNewManagerApiFlag: true,
    },
    human_online_load: {
      metricLabelI18nKey: 'metric_humanOnlineLoad',
      metricTooltipI18nKey: 'metric_humanOnlineLoad_tooltip',
      metricName: METRIC_NAMES.HUMAN_ONLINE_LOAD,
      metricUnitType: METRIC_TYPE.PERCENTAGE,
    },
    human_away_load: {
      metricLabelI18nKey: 'metric_humanAwayLoad',
      metricTooltipI18nKey: 'metric_humanAwayLoad_tooltip',
      metricName: METRIC_NAMES.HUMAN_AWAY_LOAD,
      metricUnitType: METRIC_TYPE.PERCENTAGE,
    },
    closed: {
      metricLabelI18nKey: 'metric_closed_conversation',
      metricTooltipI18nKey: 'metric_closed_conversation_tooltip',
      metricName: METRIC_NAMES.CLOSED_CONVERSATIONS,
      metricUnitType: METRIC_TYPE.NONE,
      extensionMetrics: [
        METRIC_NAMES.CLOSED_BY_AGENT, METRIC_NAMES.CLOSED_BY_CONSUMER, METRIC_NAMES.AUTO_CLOSED,
      ],
    },
    closed_by_agent: {
      metricLabelI18nKey: 'metric_closed_by_agent',
      metricTooltipI18nKey: 'metric_closed_by_agent_tooltip',
      metricName: METRIC_NAMES.CLOSED_BY_AGENT,
      metricUnitType: METRIC_TYPE.NONE,
    },
    closed_by_consumer: {
      metricLabelI18nKey: 'metric_closed_by_consumer',
      metricTooltipI18nKey: 'metric_closed_by_consumer_tooltip',
      metricName: METRIC_NAMES.CLOSED_BY_CONSUMER,
      metricUnitType: METRIC_TYPE.NONE,
    },
    auto_closed: {
      metricLabelI18nKey: 'metric_auto_closed',
      metricTooltipI18nKey: 'metric_auto_closed_tooltip',
      metricName: METRIC_NAMES.AUTO_CLOSED,
      metricUnitType: METRIC_TYPE.NONE,
    },
    csat: {
      metricLabelI18nKey: 'metric_csat',
      metricTooltipI18nKey: 'metric_csat_tooltip',
      metricName: METRIC_NAMES.CSAT,
      metricUnitType: METRIC_TYPE.PERCENTAGE,
    },
    first_response_time: {
      metricLabelI18nKey: 'metric_avg_wait_time_first_response',
      metricTooltipI18nKey: 'metric_avg_wait_time_first_response_tooltip',
      metricName: METRIC_NAMES.AVG_WAIT_TIME_FIRST_RESPONSE,
      metricUnitType: METRIC_TYPE.DURATION,
      extensionMetrics: [METRIC_NAMES.AVG_TIME_TO_FIRST_RESPONSE_FIRST_ASSIGNMENT],
    },
    first_response_time_from_assignment: {
      metricLabelI18nKey: 'metric_avg_time_to_first_response_first_assignment',
      metricTooltipI18nKey: 'metric_avg_time_to_first_response_first_assignment_tooltip',
      metricName: METRIC_NAMES.AVG_TIME_TO_FIRST_RESPONSE_FIRST_ASSIGNMENT,
      metricUnitType: METRIC_TYPE.DURATION,
    },
    response_time: {
      metricLabelI18nKey: 'metric_avg_wait_time',
      metricTooltipI18nKey: 'metric_avg_wait_time_tooltip',
      metricName: METRIC_NAMES.AVG_WAIT_TIME,
      metricUnitType: METRIC_TYPE.DURATION,
      extensionMetrics: [METRIC_NAMES.AVG_TIME_TO_RESPONSE],
    },
    response_time_from_assignment: {
      metricLabelI18nKey: 'metric_avg_time_to_response',
      metricTooltipI18nKey: 'metric_avg_time_to_response_tooltip',
      metricName: METRIC_NAMES.AVG_TIME_TO_RESPONSE,
      metricUnitType: METRIC_TYPE.DURATION,
    },
    avg_conversations_duration: {
      metricLabelI18nKey: 'metric_avg_conversations_duration',
      metricTooltipI18nKey: 'metric_avg_conversations_duration_tooltip',
      metricName: METRIC_NAMES.AVG_CONVERSATIONS_DURATION,
      metricUnitType: METRIC_TYPE.DURATION,
    },
  },
  [WIDGET_LOGICAL_NAMES.AGENTS]: {
    agent_picture: {
      metricName: METRIC_NAMES.AGENT_VIEW_AGENT_PICTURE,
      metricUnitType: METRIC_TYPE.NONE,
    },
    notifications: {
      metricLabelI18nKey: 'metric_agent_notification',
      metricColumnId: 'notifications',
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '8%',
        minWidth: '63px',
      },
      metricColumnHeaderI18nKey: 'agents_column_notifications',
      metricTooltipI18nKey: 'agents_column_notifications_tooltip',
      metricName: METRIC_NAMES.AGENT_VIEW_AGENT_NOTIFICATIONS,
      metricUnitType: METRIC_TYPE.NONE,
    },
    state: {
      metricLabelI18nKey: 'metric_state',
      metricColumnId: 'agentStatus', // sort param is different than variable param
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '8%',
        minWidth: '83px',
      },
      metricColumnHeaderI18nKey: 'agents_column_status',
      metricTooltipI18nKey: 'agents_column_status_tooltip',
      metricName: METRIC_NAMES.AGENT_VIEW_AGENT_STATUS,
      metricUnitType: METRIC_TYPE.NONE,
    },
    state_duration: {
      metricLabelI18nKey: 'metric_agent_status_duration',
      metricColumnSortable: false,
      metricColumnBaseSize: {
        width: '8%',
        minWidth: '57px',
      },
      metricColumnHeaderI18nKey: 'agents_column_status_duration',
      metricTooltipI18nKey: 'agent_metric_agent_status_duration_tooltip',
      metricReducedDisplayTooltipI18nKey: 'agent_metric_agent_status_duration_tooltip',
      metricName: METRIC_NAMES.AGENT_VIEW_AGENT_STATUS_WITH_REASON_DURATION,
      metricUnitType: METRIC_TYPE.DURATION,
    },
    online_rate: {
      metricLabelI18nKey: 'metric_online_rate',
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '8%',
        minWidth: '75px',
      },
      metricColumnHeaderI18nKey: 'agents_column_online_rate',
      metricTooltipI18nKey: 'agents_column_online_rate_tooltip',
      metricName: METRIC_NAMES.AGENT_VIEW_ONLINE_RATE,
      metricUnitType: METRIC_TYPE.PERCENTAGE,
    },
    agent_name: {
      metricLabelI18nKey: 'metric_agent_name',
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '10%',
        minWidth: '100px',
      },
      metricColumnHeaderI18nKey: 'agents_column_agent_name',
      metricTooltipI18nKey: 'agents_column_agent_name_tooltip',
      metricName: METRIC_NAMES.AGENT_VIEW_AGENT_NAME,
      metricUnitType: METRIC_TYPE.NONE,
    },
    agent_group: {
      metricLabelI18nKey: 'metric_agent_group',
      metricColumnSortable: false,
      metricColumnBaseSize: {
        width: '10%',
        minWidth: '90px',
      },
      metricColumnHeaderI18nKey: 'agents_column_agent_group',
      metricTooltipI18nKey: 'agents_column_agent_group_tooltip',
      metricName: METRIC_NAMES.AGENT_VIEW_AGENT_GROUP,
      metricUnitType: METRIC_TYPE.NONE,
    },
    skills: {
      metricLabelI18nKey: 'metric_skills',
      metricColumnSortable: false,
      metricColumnBaseSize: {
        width: '6%',
        minWidth: '50px',
      },
      metricColumnHeaderI18nKey: 'agents_column_skills',
      metricTooltipI18nKey: 'agents_column_skills_tooltip',
      metricName: METRIC_NAMES.AGENT_VIEW_AGENT_SKILLS,
      metricUnitType: METRIC_TYPE.ARRAY,
      arrayItemValueAttr: 'skillName',
    },
    assigned: {
      metricLabelI18nKey: 'metric_assigned_conversation',
      metricColumnId: 'assignedConversations', // sort param is different than variable param
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '8%',
        minWidth: '80px',
      },
      metricColumnHeaderI18nKey: 'agents_column_assigned',
      metricTooltipI18nKey: 'agents_column_assigned_tooltip',
      metricReducedDisplayTooltipI18nKey: 'agent_metric_assigned_conversation_tooltip',
      metricName: METRIC_NAMES.AGENT_VIEW_ASSIGNED_CONVERSATIONS,
      metricUnitType: METRIC_TYPE.NONE,
    },
    active: {
      metricLabelI18nKey: 'metric_active',
      metricColumnId: 'activeConversations', // sort param is different than variable param
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '6%',
        minWidth: '55px',
      },
      metricColumnHeaderI18nKey: 'agents_column_active',
      metricTooltipI18nKey: 'agents_column_active_tooltip',
      metricReducedDisplayTooltipI18nKey: 'agent_metric_active_tooltip',
      metricName: METRIC_NAMES.AGENT_VIEW_ACTIVE_CONVERSATIONS,
      metricUnitType: METRIC_TYPE.NONE,
    },
    max_open: {
      metricLabelI18nKey: 'metric_max_open',
      metricColumnId: 'maxSlots', // sort param is different than variable param
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '9%',
        minWidth: '85px',
      },
      metricColumnHeaderI18nKey: 'agents_column_max_open',
      metricTooltipI18nKey: 'agents_column_max_open_tooltip',
      metricName: METRIC_NAMES.AGENT_VIEW_MAX_SLOTS,
      metricUnitType: METRIC_TYPE.NONE,
    },
    load: {
      metricLabelI18nKey: 'metric_load',
      metricColumnId: 'agentLoad', // sort param is different than variable param
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '7%',
        minWidth: '60px',
      },
      metricColumnHeaderI18nKey: 'agents_column_load',
      metricTooltipI18nKey: 'agents_column_load_tooltip',
      metricReducedDisplayTooltipI18nKey: 'agent_metric_load_tooltip',
      metricName: METRIC_NAMES.AGENT_VIEW_AGENT_LOAD,
      metricUnitType: METRIC_TYPE.PERCENTAGE,
    },
    closed: {
      metricLabelI18nKey: 'metric_closed_conversation',
      metricColumnId: 'closedConversations', // sort param is different than variable param
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '5%',
        minWidth: '50px',
      },
      metricColumnHeaderI18nKey: 'agents_column_closed',
      metricTooltipI18nKey: 'agents_column_closed_tooltip',
      metricReducedDisplayTooltipI18nKey: 'agent_metric_closed_conversation_tooltip',
      metricName: METRIC_NAMES.AGENT_VIEW_CLOSED_CONVERSATIONS,
      metricUnitType: METRIC_TYPE.NONE,
    },
    transfer_rate: {
      metricLabelI18nKey: 'metric_transfer_rate_agents_widget',
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '6%',
        minWidth: '80px',
      },
      metricColumnHeaderI18nKey: 'agents_column_transfer_rate',
      metricTooltipI18nKey: 'agents_column_transfer_rate_tooltip',
      metricName: METRIC_NAMES.AGENT_VIEW_TRANSFER_RATE,
      metricUnitType: METRIC_TYPE.PERCENTAGE,
    },
    csat: {
      metricLabelI18nKey: 'metric_csat',
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '7%',
        minWidth: '80px',
      },
      metricColumnHeaderI18nKey: 'agents_column_csat',
      metricTooltipI18nKey: 'agents_column_csat_tooltip',
      metricReducedDisplayTooltipI18nKey: 'agent_metric_csat_tooltip',
      metricName: METRIC_NAMES.AGENT_VIEW_CSAT,
      metricUnitType: METRIC_TYPE.PERCENTAGE,
    },
  },
  [WIDGET_LOGICAL_NAMES.CONVERSATIONS]: {
    status: {
      metricLabelI18nKey: 'metric_status',
      metricColumnSortable: false,
      metricColumnBaseSize: {
        width: '8%',
        minWidth: '75px',
      },
      metricTooltipI18nKey: 'conversations_column_status_tooltip',
      metricColumnHeaderI18nKey: 'conversations_column_status',
      metricName: METRIC_NAMES.CONVERSATION_STATUS,
      metricUnitType: METRIC_TYPE.NONE,
    },
    response_time: {
      metricLabelI18nKey: 'metric_response_time',
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '12%',
        minWidth: '100px',
      },
      metricTooltipI18nKey: 'conversations_column_response_time_tooltip',
      metricColumnHeaderI18nKey: 'conversations_column_response_time',
      metricName: METRIC_NAMES.CONVERSATIONS_RESPONSE_TIME,
      metricUnitType: METRIC_TYPE.DURATION,
    },
    visitor_name: {
      metricLabelI18nKey: 'metric_visitor_name',
      metricColumnSortable: false,
      metricColumnBaseSize: {
        width: '12%',
        minWidth: '109px',
      },
      metricColumnHeaderI18nKey: 'conversations_column_visitor',
      metricName: METRIC_NAMES.VISITOR_NAME,
      metricUnitType: METRIC_TYPE.NONE,
    },
    agent_name: {
      metricLabelI18nKey: 'metric_agent_name',
      metricColumnSortable: false,
      metricColumnBaseSize: {
        width: '15%',
        minWidth: '130px',
      },
      metricTooltipI18nKey: 'conversations_column_agent_name_tooltip',
      metricColumnHeaderI18nKey: 'conversations_column_agent_name',
      metricName: METRIC_NAMES.AGENT_NAME,
      metricUnitType: METRIC_TYPE.NONE,
    },
    agent_group: {
      metricLabelI18nKey: 'metric_agent_group',
      metricColumnSortable: false,
      metricColumnBaseSize: {
        width: '15%',
        minWidth: '100px',
      },
      metricTooltipI18nKey: 'conversations_column_agent_group_tooltip',
      metricColumnHeaderI18nKey: 'conversations_column_agent_group',
      metricName: METRIC_NAMES.AGENT_GROUP,
      metricUnitType: METRIC_TYPE.NONE,
    },
    skill: {
      metricLabelI18nKey: 'metric_skill',
      metricColumnSortable: false,
      metricColumnBaseSize: {
        width: '12%',
        minWidth: '105px',
      },
      metricTooltipI18nKey: 'conversations_column_skill_tooltip',
      metricColumnHeaderI18nKey: 'conversations_column_skill',
      metricName: METRIC_NAMES.CONVERSATION_SKILL,
      metricUnitType: METRIC_TYPE.NONE,
    },
    start_time: {
      metricLabelI18nKey: 'metric_start_time',
      metricColumnSortable: false,
      metricColumnBaseSize: {
        width: '11%',
        minWidth: '90px',
      },
      metricTooltipI18nKey: 'conversations_column_start_time_tooltip',
      metricColumnHeaderI18nKey: 'conversations_column_start_time',
      metricName: METRIC_NAMES.CONVERSATION_START_TIME,
      metricUnitType: METRIC_TYPE.NONE,
    },
    mcs: {
      metricLabelI18nKey: 'metric_mcs',
      metricColumnSortable: false,
      metricColumnBaseSize: {
        width: '5%',
        minWidth: '45px',
      },
      metricTooltipI18nKey: 'conversations_column_mcs_tooltip',
      metricColumnHeaderI18nKey: 'conversations_column_mcs',
      metricName: METRIC_NAMES.MCS,
      metricUnitType: METRIC_TYPE.NONE,
    },
    csat: {
      metricLabelI18nKey: 'metric_csat',
      metricColumnSortable: false,
      metricColumnBaseSize: {
        width: '5%',
        minWidth: '45px',
      },
      metricTooltipI18nKey: 'conversations_column_csat_tooltip',
      metricColumnHeaderI18nKey: 'conversations_column_csat',
      metricName: METRIC_NAMES.CSAT,
      metricUnitType: METRIC_TYPE.NONE,
    },
    nps: {
      metricLabelI18nKey: 'metric_nps',
      metricColumnSortable: false,
      metricColumnBaseSize: {
        width: '5%',
        minWidth: '45px',
      },
      metricTooltipI18nKey: 'conversations_column_nps_tooltip',
      metricColumnHeaderI18nKey: 'conversations_column_nps',
      metricName: METRIC_NAMES.NPS,
      metricUnitType: METRIC_TYPE.NONE,
    },
    brand_name: {
      metricLabelI18nKey: 'metric_brand_name',
      metricColumnSortable: false,
      metricColumnBaseSize: {
        width: '10%',
        minWidth: '80px',
      },
      metricTooltipI18nKey: 'conversations_column_brand_tooltip',
      metricColumnHeaderI18nKey: 'conversations_column_brand',
      metricName: METRIC_NAMES.BRAND_NAME,
      metricUnitType: METRIC_TYPE.NONE,
    },
    intents: {
      metricLabelI18nKey: 'metric_conversation_intents',
      metricColumnSortable: false,
      metricColumnBaseSize: {
        width: '10%',
        minWidth: '80px',
      },
      metricTooltipI18nKey: 'conversations_column_intents_tooltip',
      metricColumnHeaderI18nKey: 'conversations_column_intents',
      metricName: METRIC_NAMES.CONVERSATION_INTENTS,
      metricUnitType: METRIC_TYPE.ARRAY,
      arrayItemValueAttr: 'intentLabel',
    },
    close_reason: {
      metricLabelI18nKey: 'metric_close_reason',
      metricColumnSortable: false,
      metricColumnBaseSize: {
        width: '8%',
        minWidth: '110px',
      },
      metricTooltipI18nKey: 'conversations_column_close_reason_tooltip',
      metricColumnHeaderI18nKey: 'conversations_column_close_reason',
      metricName: METRIC_NAMES.CLOSE_REASON,
      metricUnitType: METRIC_TYPE.NONE,
    },
  },
  [WIDGET_LOGICAL_NAMES.SKILLS]: {
    skill_name: {
      metricLabelI18nKey: 'metric_skill_name',
      metricColumnSortable: false,
      metricColumnBaseSize: {
        width: '7%',
        minWidth: '150px',
      },
      metricColumnHeaderI18nKey: 'skills_column_skill_name',
      metricName: METRIC_NAMES.SKILLS_SKILL_NAME,
      metricUnitType: METRIC_TYPE.NONE,
    },
    open_conversations: {
      metricLabelI18nKey: 'metric_open_conversations',
      metricColumnSortable: false,
      metricColumnBaseSize: {
        width: '3%',
        minWidth: '65px',
      },
      metricTooltipI18nKey: 'skills_column_open_conversations_tooltip',
      metricColumnHeaderI18nKey: 'skills_column_open_conversations',
      metricName: METRIC_NAMES.SKILL_OPEN_CONVERSATIONS,
      metricUnitType: METRIC_TYPE.NONE,
    },
    overdue_conversations: {
      metricLabelI18nKey: 'metric_overdue_conversations',
      metricColumnSortable: false,
      metricColumnBaseSize: {
        width: '4%',
        minWidth: '90px',
      },
      metricTooltipI18nKey: 'skills_column_overdue_conversations_tooltip',
      metricColumnHeaderI18nKey: 'skills_column_overdue_conversations',
      metricName: METRIC_NAMES.OVERDUE_TOTAL,
      metricUnitType: METRIC_TYPE.NONE,
    },
    unassigned_conversations: {
      metricLabelI18nKey: 'metric_unassigned_conversations',
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '5%',
        minWidth: '110px',
      },
      metricTooltipI18nKey: 'queue_health_column_in_queue_tooltip',
      metricColumnHeaderI18nKey: 'skills_column_unassigned_conversations',
      metricName: METRIC_NAMES.SKILL_UNASSIGNED_CONVERSATIONS,
      metricUnitType: METRIC_TYPE.NONE,
    },
    actionable_conversations: {
      metricLabelI18nKey: 'metric_actionable_conversations',
      metricColumnSortable: false,
      metricColumnBaseSize: {
        width: '5%',
        minWidth: '105px',
      },
      metricTooltipI18nKey: 'skills_column_actionable_conversations_tooltip',
      metricColumnHeaderI18nKey: 'skills_column_actionable_conversations',
      metricName: METRIC_NAMES.ACTIONABLE,
      metricUnitType: METRIC_TYPE.NONE,
    },
    overdue_unassigned_conversations: {
      metricLabelI18nKey: 'metric_overdue_unassigned_conversations',
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '8%',
        minWidth: '165px',
      },
      metricTooltipI18nKey: 'skills_column_overdue_unassigned_conversations_tooltip',
      metricColumnHeaderI18nKey: 'skills_column_overdue_unassigned_conversations',
      metricName: METRIC_NAMES.OVERDUE_IN_QUEUE,
      metricUnitType: METRIC_TYPE.NONE,
    },
    wait_time_agent_assignment_50_percentile: {
      metricLabelI18nKey: 'metric_wait_time_agent_assignment_50_percentile',
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '6%',
        minWidth: '130px',
      },
      metricTooltipI18nKey: 'skills_column_wait_time_agent_assignment_50_percentile_tooltip',
      metricColumnHeaderI18nKey: 'skills_column_wait_time_agent_assignment_50_percentile',
      metricName: METRIC_NAMES.SKILL_WAIT_TIME_AGENT_ASSIGNMENT_50_PERCENTILE,
      metricUnitType: METRIC_TYPE.DURATION,
    },
    wait_time_agent_assignment_90_percentile: {
      metricLabelI18nKey: 'metric_wait_time_agent_assignment_90_percentile',
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '6%',
        minWidth: '130px',
      },
      metricTooltipI18nKey: 'skills_column_wait_time_agent_assignment_90_percentile_tooltip',
      metricColumnHeaderI18nKey: 'skills_column_wait_time_agent_assignment_90_percentile',
      metricName: METRIC_NAMES.SKILL_WAIT_TIME_AGENT_ASSIGNMENT_90_PERCENTILE,
      metricUnitType: METRIC_TYPE.DURATION,
    },
    assigned_conversations: {
      metricLabelI18nKey: 'metric_assigned_conversations',
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '5%',
        minWidth: '90px',
      },
      metricTooltipI18nKey: 'skills_column_assigned_conversations_tooltip',
      metricColumnHeaderI18nKey: 'skills_column_assigned_conversations',
      metricName: METRIC_NAMES.SKILL_ASSIGNED_CONVERSATIONS,
      metricUnitType: METRIC_TYPE.NONE,
    },
    overdue_assigned_conversations: {
      metricLabelI18nKey: 'metric_overdue_assigned_conversations',
      metricColumnSortable: false,
      metricColumnBaseSize: {
        width: '7%',
        minWidth: '150px',
      },
      metricTooltipI18nKey: 'skills_column_overdue_assigned_conversations_tooltip',
      metricColumnHeaderI18nKey: 'skills_column_overdue_assigned_conversations',
      metricName: METRIC_NAMES.OVERDUE_ASSIGNED,
      metricUnitType: METRIC_TYPE.NONE,
    },
    skill_load: {
      metricLabelI18nKey: 'metric_skill_load',
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '4%',
        minWidth: '70px',
      },
      metricTooltipI18nKey: 'skills_column_skill_load_tooltip',
      metricColumnHeaderI18nKey: 'skills_column_skill_load',
      metricName: METRIC_NAMES.SKILL_LOAD,
      metricUnitType: METRIC_TYPE.PERCENTAGE,
    },
    skill_online_agents: {
      metricLabelI18nKey: 'metric_skill_online_agents',
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '4%',
        minWidth: '75px',
      },
      metricTooltipI18nKey: 'skills_column_skill_online_agents_tooltip',
      metricColumnHeaderI18nKey: 'skills_column_skill_online_agents',
      metricName: METRIC_NAMES.SKILL_ONLINE_AGENTS,
      metricUnitType: METRIC_TYPE.NONE,
    },
    skill_away_agents: {
      metricLabelI18nKey: 'metric_skill_away_agents',
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '4%',
        minWidth: '75px',
      },
      metricTooltipI18nKey: 'skills_column_skill_away_agents_tooltip',
      metricColumnHeaderI18nKey: 'skills_column_skill_away_agents',
      metricName: METRIC_NAMES.SKILL_AWAY_AGENTS,
      metricUnitType: METRIC_TYPE.NONE,
    },
    skill_back_soon_agents: {
      metricLabelI18nKey: 'metric_skill_back_soon_agents',
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '5%',
        minWidth: '100px',
      },
      metricTooltipI18nKey: 'skills_column_skill_back_soon_agents_tooltip',
      metricColumnHeaderI18nKey: 'skills_column_skill_back_soon_agents',
      metricName: METRIC_NAMES.SKILL_BACK_SOON_AGENTS,
      metricUnitType: METRIC_TYPE.NONE,
    },
    closed_conversations: {
      metricLabelI18nKey: 'metric_closed_conversations',
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '4%',
        minWidth: '80px',
      },
      metricTooltipI18nKey: 'skills_column_closed_conversations_tooltip',
      metricColumnHeaderI18nKey: 'skills_column_closed_conversations',
      metricName: METRIC_NAMES.SKILL_CLOSED_CONVERSATIONS,
      metricUnitType: METRIC_TYPE.NONE,
    },
    average_wait_time_first_response: {
      metricLabelI18nKey: 'metric_average_wait_time_first_response',
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '4%',
        minWidth: '70px',
      },
      metricTooltipI18nKey: 'skills_column_average_wait_time_first_response_tooltip',
      metricColumnHeaderI18nKey: 'skills_column_average_wait_time_first_response',
      metricName: METRIC_NAMES.AVG_WAIT_TIME_FIRST_RESPONSE,
      metricUnitType: METRIC_TYPE.DURATION,
    },
    average_time_to_first_response_first_assignment: {
      metricLabelI18nKey: 'metric_average_time_to_first_response_first_assignment',
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '8%',
        minWidth: '170px',
      },
      metricTooltipI18nKey: 'skills_column_average_time_to_first_response_first_assignment_tooltip',
      metricColumnHeaderI18nKey: 'skills_column_average_time_to_first_response_first_assignment',
      metricName: METRIC_NAMES.AVG_TIME_TO_FIRST_RESPONSE_FIRST_ASSIGNMENT,
      metricUnitType: METRIC_TYPE.DURATION,
    },
    average_wait_time: {
      metricLabelI18nKey: 'metric_average_wait_time',
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '4%',
        minWidth: '70px',
      },
      metricTooltipI18nKey: 'skills_column_average_wait_time_tooltip',
      metricColumnHeaderI18nKey: 'skills_column_average_wait_time',
      metricName: METRIC_NAMES.AVG_WAIT_TIME,
      metricUnitType: METRIC_TYPE.DURATION,
    },
    average_time_to_response: {
      metricLabelI18nKey: 'metric_average_time_to_response',
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '7%',
        minWidth: '135px',
      },
      metricTooltipI18nKey: 'skills_column_average_time_to_response_tooltip',
      metricColumnHeaderI18nKey: 'skills_column_average_time_to_response',
      metricName: METRIC_NAMES.AVG_TIME_TO_RESPONSE,
      metricUnitType: METRIC_TYPE.DURATION,
    },
  },
  [WIDGET_LOGICAL_NAMES.BOTS]: {
    bot_picture: {
      metricName: METRIC_NAMES.AGENT_VIEW_AGENT_PICTURE,
      metricUnitType: METRIC_TYPE.NONE,
    },
    notifications: {
      metricLabelI18nKey: 'metric_agent_notification', // same key used as in agents
      metricColumnId: 'notifications',
      metricColumnSortable: false,
      metricColumnBaseSize: {
        width: '8%',
        minWidth: '63px',
      },
      metricColumnHeaderI18nKey: 'bots_column_notifications',
      metricTooltipI18nKey: 'bots_column_notifications_tooltip',
      metricName: METRIC_NAMES.AGENT_VIEW_AGENT_NOTIFICATIONS,
      metricUnitType: METRIC_TYPE.NONE,
    },
    bot_status: {
      metricLabelI18nKey: 'metric_state',
      metricColumnId: 'agentStatus', // sort param is different than variable param
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '9%',
        minWidth: '90px',
      },
      metricColumnHeaderI18nKey: 'bots_column_status',
      metricTooltipI18nKey: 'bots_column_status_tooltip',
      metricName: METRIC_NAMES.AGENT_VIEW_AGENT_STATUS,
      metricUnitType: METRIC_TYPE.NONE,
    },
    bot_name: {
      metricLabelI18nKey: 'metric_bot_name',
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '11%',
        minWidth: '110px',
      },
      metricColumnHeaderI18nKey: 'bots_column_bot_name',
      metricTooltipI18nKey: 'bots_column_bot_name_tooltip',
      metricName: METRIC_NAMES.AGENT_VIEW_AGENT_NAME,
      metricUnitType: METRIC_TYPE.NONE,
    },
    bot_group: {
      metricLabelI18nKey: 'metric_bot_group',
      metricColumnSortable: false,
      metricColumnBaseSize: {
        width: '11%',
        minWidth: '110px',
      },
      metricColumnHeaderI18nKey: 'bots_column_bot_group',
      metricTooltipI18nKey: 'bots_column_bot_group_tooltip',
      metricName: METRIC_NAMES.AGENT_VIEW_AGENT_GROUP,
      metricUnitType: METRIC_TYPE.NONE,
    },
    bot_skills: {
      metricLabelI18nKey: 'metric_skills',
      metricColumnSortable: false,
      metricColumnBaseSize: {
        width: '13%',
        minWidth: '120px',
      },
      metricColumnHeaderI18nKey: 'bots_column_bot_skills',
      metricTooltipI18nKey: 'bots_column_bot_skills_tooltip',
      metricName: METRIC_NAMES.AGENT_VIEW_AGENT_SKILLS,
      metricUnitType: METRIC_TYPE.ARRAY,
      arrayItemValueAttr: 'skillName',
    },
    assigned_conversations: {
      metricLabelI18nKey: 'metric_assigned_conversation',
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '8%',
        minWidth: '80px',
      },
      metricColumnHeaderI18nKey: 'bots_column_assigned',
      metricTooltipI18nKey: 'bots_column_assigned_tooltip',
      metricName: METRIC_NAMES.AGENT_VIEW_ASSIGNED_CONVERSATIONS,
      metricUnitType: METRIC_TYPE.NONE,
    },
    pending_rate: {
      metricLabelI18nKey: 'metric_pending',
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '8%',
        minWidth: '80px',
      },
      metricColumnHeaderI18nKey: 'bots_column_pending',
      metricTooltipI18nKey: 'bots_column_pending_tooltip',
      metricName: METRIC_NAMES.AGENT_VIEW_PENDING_RATE,
      metricUnitType: METRIC_TYPE.PERCENTAGE,
    },
    concluded_conversations: {
      metricLabelI18nKey: 'metric_concluded_conversations',
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '8%',
        minWidth: '80px',
      },
      metricColumnHeaderI18nKey: 'bots_column_concluded_conversations',
      metricTooltipI18nKey: 'bots_column_concluded_conversations_tooltip',
      metricName: METRIC_NAMES.AGENT_VIEW_CONCLUDED_CONVERSATIONS,
      metricUnitType: METRIC_TYPE.NONE,
    },
    transfer_rate: {
      metricLabelI18nKey: 'metric_transfer_rate',
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '8%',
        minWidth: '80px',
      },
      metricColumnHeaderI18nKey: 'bots_column_escalated',
      metricTooltipI18nKey: 'bots_column_escalated_tooltip',
      metricName: METRIC_NAMES.AGENT_VIEW_TRANSFER_RATE,
      metricUnitType: METRIC_TYPE.PERCENTAGE,
    },
    closed_rate: {
      metricLabelI18nKey: 'metric_closed_rate',
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '8%',
        minWidth: '80px',
      },
      metricColumnHeaderI18nKey: 'bots_column_closed_rate',
      metricTooltipI18nKey: 'bots_column_closed_rate_tooltip',
      metricName: METRIC_NAMES.AGENT_VIEW_CLOSED_RATE,
      metricUnitType: METRIC_TYPE.PERCENTAGE,
    },
    bot_intents: {
      metricLabelI18nKey: 'metric_conversation_intents_matched',
      metricColumnSortable: true,
      metricColumnBaseSize: {
        width: '8%',
        minWidth: '80px',
      },
      metricColumnHeaderI18nKey: 'bots_column_intents',
      metricTooltipI18nKey: 'bots_column_intents_matched_tooltip',
      metricName: METRIC_NAMES.AGENT_VIEW_INTENTS_MATCHED_RATE,
      metricUnitType: METRIC_TYPE.PERCENTAGE,
    },
    bot_csat: {
      metricLabelI18nKey: 'metric_csat',
      metricColumnSortable: false,
      metricColumnBaseSize: {
        width: '8%',
        minWidth: '80px',
      },
      metricColumnHeaderI18nKey: 'bots_column_csat',
      metricTooltipI18nKey: 'bots_column_csat_tooltip',
      metricName: METRIC_NAMES.CSAT,
      metricUnitType: METRIC_TYPE.PERCENTAGE,
    },
  },
};

export {
  metricsConfig,
};
